import { ILogin } from './../interfaces/Ilogin'
import * as UH from './../util/UrlHttp'
import axios from 'axios'
import { IUser } from '../interfaces/IUser';

export const Login = async (data:ILogin) => {

    return await axios.post(`${UH.BASE_URL}auth/login`, data, UH.HEADER_HTTP)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const ChangePassword = async (data:ILogin, token:string|null) => {

    let header = UH.HEADER_HTTP_TOKEN

    if (token !== null) 
        header.headers.Authorization = `Bearer ${token}`  
    
    return await axios.post(`${UH.BASE_URL}changePassword`, data, header)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const GetAllUsers = async (data:any) => { 

    return await axios.post(`${UH.BASE_URL}user/getall`, data, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const GetInfoUser = async (id:string|undefined) => { 

    return await axios.get(`${UH.BASE_URL}user/${id}`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });

}

export const CreateUser = async (dataUser:IUser) => { 

    return await axios.post(`${UH.BASE_URL}user`, dataUser, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });

}

export const UpdateUser = async (dataUser:IUser) => { 

    return await axios.post(`${UH.BASE_URL}user/${dataUser.id}`, dataUser, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });

}

export const ResetPassUser = async (id:number|string|undefined) => {
    
    return await axios.post(`${UH.BASE_URL}resetPassword/${id}`, [], UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const RemoveUser = async (id:number|string|undefined) => { 

    return await axios.delete(`${UH.BASE_URL}user/${id}`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });

}

export const GetCs = async () => { 

    return await axios.get(`${UH.BASE_URL}getAllCs`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });

}

export const GetConfig = async () => {
    return await axios.get(`${UH.BASE_URL}config`, UH.HEADER_HTTP)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const UpdateCountry = async (data: { id: string | number; country_id: number | null }) => {
    return await axios.post(`${UH.BASE_URL}updateCountry`, data, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const ImportUsers = async (data: { users: any[] }) => {
    return await axios.post(`${UH.BASE_URL}user/import`, data, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const GetDepartments = async () => {
    return await axios.get(`${UH.BASE_URL}getAllDepartments`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}
